// eslint-disable-next-line no-warning-comments
// TODO: replace with material
import React from "react";
import { merge, noop, omit } from "lodash";

interface Props {
  name: string;
  label: string;
  onChangeAction: (props: Props, e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  labelStyle: React.CSSProperties;
}

const styles = {
  input: {
    position: "absolute",
    top: 2,
    left: 0,
    fontSize: 20,
  },
  label: {
    marginLeft: 11,
    marginTop: 5,
    width: "100%",
    cursor: "pointer",
  },
};

// Basic Input component that provides support for a
// label, onChange/onBlur actions, and uses a generic formData
// map to fill it's own value if present in map
export const CheckboxBasic: React.SFC<Props & React.HTMLProps<HTMLInputElement>> = props => {
  const { name, label, labelStyle, onChangeAction = noop } = props;
  const newProps = omit(props, [
    "formData",
    "inline",
    "onChangeAction",
    "persistTableName",
    "validationSchema",
    "labelStyle",
  ]);
  return (
    <div
      style={{
        position: "relative",
        marginLeft: 16,
        paddingRight: 16, // cancel out margin for cols
      }}
    >
      <input
        type="checkbox"
        name={name}
        id={name}
        onChange={onChangeAction.bind(null, props)}
        {...newProps}
        style={merge({}, styles.input, newProps.style || {})}
      />

      {label && (
        <label htmlFor={name} style={{ ...styles.label, ...labelStyle }}>
          {label}
        </label>
      )}
    </div>
  );
};
